import Editor from "../Editor";
import EditorConfig from "../EditorConfig";

const RightPanel = () => {
  return (
    <>
      <EditorConfig />
      <Editor />
    </>
  );
};

export default RightPanel;
